package io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.Icons

public val Icons.LinuxSimpleIcons: ImageVector
    get() {
        if (_linuxSimpleIcons != null) {
            return _linuxSimpleIcons!!
        }
        _linuxSimpleIcons = Builder(name = "LinuxSimpleIcons", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(12.50f, 0.0f)
                curveToRelative(-0.16f, 0.0f, -0.32f, 0.01f, -0.48f, 0.02f)
                curveToRelative(-4.23f, 0.33f, -3.11f, 4.81f, -3.17f, 6.30f)
                curveToRelative(-0.08f, 1.09f, -0.3f, 1.95f, -1.05f, 3.02f)
                curveToRelative(-0.89f, 1.05f, -2.13f, 2.75f, -2.72f, 4.52f)
                curveToRelative(-0.28f, 0.83f, -0.41f, 1.68f, -0.29f, 2.49f)
                arcToRelative(0.42f, 0.42f, 0.0f, false, false, -0.11f, 0.14f)
                curveToRelative(-0.26f, 0.27f, -0.45f, 0.6f, -0.66f, 0.84f)
                curveToRelative(-0.20f, 0.20f, -0.49f, 0.27f, -0.80f, 0.4f)
                curveToRelative(-0.31f, 0.14f, -0.66f, 0.27f, -0.86f, 0.68f)
                curveToRelative(-0.09f, 0.19f, -0.14f, 0.39f, -0.13f, 0.60f)
                curveToRelative(0.0f, 0.20f, 0.03f, 0.4f, 0.06f, 0.54f)
                curveToRelative(0.06f, 0.40f, 0.12f, 0.73f, 0.04f, 0.97f)
                curveToRelative(-0.25f, 0.68f, -0.28f, 1.15f, -0.11f, 1.48f)
                curveToRelative(0.17f, 0.33f, 0.54f, 0.47f, 0.94f, 0.60f)
                curveToRelative(0.81f, 0.2f, 1.91f, 0.14f, 2.77f, 0.6f)
                curveToRelative(0.93f, 0.47f, 1.87f, 0.67f, 2.62f, 0.47f)
                curveToRelative(0.53f, -0.12f, 0.97f, -0.46f, 1.21f, -0.95f)
                curveToRelative(0.59f, -0.00f, 1.23f, -0.27f, 2.26f, -0.33f)
                curveToRelative(0.70f, -0.06f, 1.57f, 0.27f, 2.58f, 0.2f)
                curveToRelative(0.03f, 0.13f, 0.06f, 0.20f, 0.11f, 0.33f)
                lineToRelative(0.00f, 0.00f)
                curveToRelative(0.39f, 0.78f, 1.11f, 1.13f, 1.88f, 1.07f)
                curveToRelative(0.77f, -0.06f, 1.59f, -0.54f, 2.26f, -1.31f)
                curveToRelative(0.63f, -0.77f, 1.68f, -1.08f, 2.38f, -1.50f)
                curveToRelative(0.35f, -0.20f, 0.63f, -0.47f, 0.65f, -0.85f)
                curveToRelative(0.02f, -0.4f, -0.2f, -0.81f, -0.71f, -1.38f)
                verticalLineToRelative(-0.10f)
                lineToRelative(-0.00f, -0.00f)
                curveToRelative(-0.17f, -0.2f, -0.25f, -0.54f, -0.34f, -0.93f)
                curveToRelative(-0.09f, -0.40f, -0.18f, -0.79f, -0.49f, -1.05f)
                horizontalLineToRelative(-0.00f)
                curveToRelative(-0.06f, -0.05f, -0.12f, -0.07f, -0.19f, -0.14f)
                arcToRelative(0.36f, 0.36f, 0.0f, false, false, -0.19f, -0.06f)
                curveToRelative(0.43f, -1.28f, 0.26f, -2.55f, -0.17f, -3.69f)
                curveToRelative(-0.53f, -1.41f, -1.47f, -2.64f, -2.18f, -3.48f)
                curveToRelative(-0.80f, -1.01f, -1.58f, -1.96f, -1.56f, -3.37f)
                curveToRelative(0.03f, -2.15f, 0.24f, -6.13f, -3.54f, -6.14f)
                close()
                moveTo(13.03f, 3.41f)
                horizontalLineToRelative(0.01f)
                curveToRelative(0.21f, 0.0f, 0.40f, 0.06f, 0.58f, 0.20f)
                curveToRelative(0.19f, 0.14f, 0.33f, 0.33f, 0.44f, 0.53f)
                curveToRelative(0.11f, 0.26f, 0.16f, 0.46f, 0.17f, 0.72f)
                curveToRelative(0.0f, -0.02f, 0.01f, -0.04f, 0.01f, -0.06f)
                verticalLineToRelative(0.11f)
                arcToRelative(0.09f, 0.09f, 0.0f, false, true, -0.00f, -0.02f)
                lineToRelative(-0.00f, -0.02f)
                arcToRelative(1.81f, 1.81f, 0.0f, false, true, -0.15f, 0.71f)
                arcToRelative(0.95f, 0.95f, 0.0f, false, true, -0.21f, 0.34f)
                arcToRelative(0.71f, 0.71f, 0.0f, false, false, -0.09f, -0.04f)
                curveToRelative(-0.10f, -0.05f, -0.20f, -0.06f, -0.28f, -0.13f)
                arcToRelative(1.31f, 1.31f, 0.0f, false, false, -0.22f, -0.07f)
                curveToRelative(0.05f, -0.06f, 0.15f, -0.13f, 0.18f, -0.20f)
                curveToRelative(0.05f, -0.13f, 0.08f, -0.26f, 0.09f, -0.40f)
                verticalLineToRelative(-0.02f)
                arcToRelative(1.21f, 1.21f, 0.0f, false, false, -0.06f, -0.4f)
                curveToRelative(-0.05f, -0.13f, -0.10f, -0.2f, -0.18f, -0.33f)
                curveToRelative(-0.08f, -0.07f, -0.17f, -0.13f, -0.27f, -0.13f)
                horizontalLineToRelative(-0.02f)
                curveToRelative(-0.09f, 0.0f, -0.18f, 0.03f, -0.26f, 0.13f)
                arcToRelative(0.8f, 0.8f, 0.0f, false, false, -0.21f, 0.33f)
                arcToRelative(1.18f, 1.18f, 0.0f, false, false, -0.09f, 0.4f)
                verticalLineToRelative(0.02f)
                curveToRelative(0.00f, 0.09f, 0.01f, 0.18f, 0.02f, 0.27f)
                curveToRelative(-0.19f, -0.07f, -0.44f, -0.14f, -0.61f, -0.20f)
                arcToRelative(1.64f, 1.64f, 0.0f, false, true, -0.02f, -0.2f)
                verticalLineToRelative(-0.02f)
                arcToRelative(1.77f, 1.77f, 0.0f, false, true, 0.15f, -0.77f)
                curveToRelative(0.08f, -0.22f, 0.23f, -0.41f, 0.43f, -0.53f)
                arcToRelative(0.99f, 0.99f, 0.0f, false, true, 0.59f, -0.2f)
                close()
                moveTo(10.07f, 3.46f)
                horizontalLineToRelative(0.04f)
                curveToRelative(0.14f, 0.0f, 0.27f, 0.05f, 0.40f, 0.14f)
                curveToRelative(0.15f, 0.13f, 0.26f, 0.29f, 0.34f, 0.47f)
                curveToRelative(0.09f, 0.20f, 0.14f, 0.4f, 0.15f, 0.67f)
                verticalLineToRelative(0.00f)
                curveToRelative(0.01f, 0.13f, 0.01f, 0.2f, -0.00f, 0.27f)
                verticalLineToRelative(0.08f)
                curveToRelative(-0.03f, 0.01f, -0.06f, 0.02f, -0.08f, 0.02f)
                curveToRelative(-0.15f, 0.06f, -0.27f, 0.14f, -0.39f, 0.2f)
                curveToRelative(0.01f, -0.09f, 0.01f, -0.18f, 0.00f, -0.27f)
                verticalLineToRelative(-0.02f)
                curveToRelative(-0.01f, -0.13f, -0.04f, -0.2f, -0.08f, -0.33f)
                arcToRelative(0.61f, 0.61f, 0.0f, false, false, -0.17f, -0.27f)
                arcToRelative(0.25f, 0.25f, 0.0f, false, false, -0.18f, -0.06f)
                horizontalLineToRelative(-0.02f)
                curveToRelative(-0.07f, 0.01f, -0.13f, 0.04f, -0.19f, 0.13f)
                arcToRelative(0.55f, 0.55f, 0.0f, false, false, -0.12f, 0.27f)
                arcToRelative(0.94f, 0.94f, 0.0f, false, false, -0.02f, 0.33f)
                verticalLineToRelative(0.02f)
                curveToRelative(0.01f, 0.14f, 0.04f, 0.2f, 0.08f, 0.33f)
                curveToRelative(0.05f, 0.13f, 0.10f, 0.2f, 0.17f, 0.27f)
                curveToRelative(0.01f, 0.01f, 0.02f, 0.02f, 0.03f, 0.02f)
                curveToRelative(-0.07f, 0.06f, -0.12f, 0.07f, -0.18f, 0.14f)
                arcToRelative(0.30f, 0.30f, 0.0f, false, true, -0.13f, 0.07f)
                arcToRelative(2.62f, 2.62f, 0.0f, false, true, -0.28f, -0.40f)
                arcToRelative(1.77f, 1.77f, 0.0f, false, true, -0.16f, -0.67f)
                arcToRelative(1.76f, 1.76f, 0.0f, false, true, 0.08f, -0.67f)
                arcToRelative(1.43f, 1.43f, 0.0f, false, true, 0.28f, -0.54f)
                curveToRelative(0.13f, -0.13f, 0.26f, -0.2f, 0.42f, -0.2f)
                close()
                moveTo(11.44f, 5.17f)
                curveToRelative(0.33f, 0.0f, 0.73f, 0.07f, 1.22f, 0.40f)
                curveToRelative(0.29f, 0.2f, 0.52f, 0.27f, 1.05f, 0.47f)
                horizontalLineToRelative(0.00f)
                curveToRelative(0.26f, 0.14f, 0.41f, 0.27f, 0.48f, 0.40f)
                verticalLineToRelative(-0.13f)
                arcToRelative(0.57f, 0.57f, 0.0f, false, true, 0.02f, 0.47f)
                curveToRelative(-0.12f, 0.31f, -0.52f, 0.64f, -1.06f, 0.84f)
                verticalLineToRelative(0.00f)
                curveToRelative(-0.27f, 0.14f, -0.50f, 0.33f, -0.78f, 0.47f)
                curveToRelative(-0.28f, 0.14f, -0.59f, 0.29f, -1.01f, 0.27f)
                arcToRelative(1.14f, 1.14f, 0.0f, false, true, -0.45f, -0.07f)
                arcToRelative(3.57f, 3.57f, 0.0f, false, true, -0.32f, -0.20f)
                curveToRelative(-0.20f, -0.14f, -0.36f, -0.33f, -0.61f, -0.47f)
                verticalLineToRelative(-0.01f)
                horizontalLineToRelative(-0.01f)
                curveToRelative(-0.4f, -0.25f, -0.62f, -0.51f, -0.69f, -0.71f)
                curveToRelative(-0.07f, -0.27f, -0.01f, -0.47f, 0.19f, -0.6f)
                curveToRelative(0.22f, -0.14f, 0.38f, -0.27f, 0.48f, -0.34f)
                curveToRelative(0.10f, -0.07f, 0.14f, -0.10f, 0.18f, -0.13f)
                horizontalLineToRelative(0.00f)
                verticalLineToRelative(-0.00f)
                curveToRelative(0.17f, -0.20f, 0.44f, -0.47f, 0.84f, -0.60f)
                curveToRelative(0.14f, -0.04f, 0.29f, -0.07f, 0.47f, -0.07f)
                close()
                moveTo(14.24f, 7.31f)
                curveToRelative(0.36f, 1.42f, 1.20f, 3.48f, 1.74f, 4.47f)
                curveToRelative(0.29f, 0.53f, 0.86f, 1.66f, 1.10f, 3.02f)
                curveToRelative(0.16f, -0.01f, 0.33f, 0.02f, 0.51f, 0.06f)
                curveToRelative(0.65f, -1.67f, -0.55f, -3.47f, -1.09f, -3.97f)
                curveToRelative(-0.22f, -0.2f, -0.23f, -0.34f, -0.12f, -0.34f)
                curveToRelative(0.59f, 0.53f, 1.37f, 1.57f, 1.65f, 2.76f)
                curveToRelative(0.13f, 0.54f, 0.16f, 1.10f, 0.02f, 1.67f)
                curveToRelative(0.07f, 0.03f, 0.14f, 0.06f, 0.21f, 0.07f)
                curveToRelative(1.03f, 0.53f, 1.41f, 0.94f, 1.23f, 1.54f)
                verticalLineToRelative(-0.04f)
                curveToRelative(-0.06f, -0.00f, -0.12f, 0.0f, -0.18f, 0.0f)
                horizontalLineToRelative(-0.02f)
                curveToRelative(0.15f, -0.47f, -0.18f, -0.83f, -1.07f, -1.22f)
                curveToRelative(-0.92f, -0.4f, -1.65f, -0.34f, -1.77f, 0.47f)
                curveToRelative(-0.01f, 0.04f, -0.01f, 0.07f, -0.02f, 0.14f)
                curveToRelative(-0.07f, 0.02f, -0.14f, 0.05f, -0.21f, 0.06f)
                curveToRelative(-0.43f, 0.27f, -0.66f, 0.67f, -0.79f, 1.19f)
                curveToRelative(-0.13f, 0.53f, -0.17f, 1.16f, -0.21f, 1.87f)
                verticalLineToRelative(0.00f)
                curveToRelative(-0.02f, 0.33f, -0.17f, 0.84f, -0.32f, 1.35f)
                curveToRelative(-1.5f, 1.07f, -3.58f, 1.54f, -5.35f, 0.33f)
                arcToRelative(2.65f, 2.65f, 0.0f, false, false, -0.40f, -0.53f)
                arcToRelative(1.45f, 1.45f, 0.0f, false, false, -0.28f, -0.33f)
                curveToRelative(0.18f, 0.0f, 0.34f, -0.03f, 0.47f, -0.07f)
                arcToRelative(0.62f, 0.62f, 0.0f, false, false, 0.31f, -0.33f)
                curveToRelative(0.11f, -0.27f, 0.0f, -0.70f, -0.35f, -1.16f)
                curveToRelative(-0.35f, -0.47f, -0.93f, -1.00f, -1.79f, -1.52f)
                curveToRelative(-0.63f, -0.4f, -0.99f, -0.87f, -1.15f, -1.40f)
                curveToRelative(-0.17f, -0.53f, -0.14f, -1.09f, -0.02f, -1.65f)
                curveToRelative(0.25f, -1.07f, 0.87f, -2.11f, 1.27f, -2.76f)
                curveToRelative(0.11f, -0.07f, 0.04f, 0.14f, -0.41f, 0.97f)
                curveToRelative(-0.40f, 0.75f, -1.14f, 2.50f, -0.12f, 3.85f)
                arcToRelative(8.12f, 8.12f, 0.0f, false, true, 0.65f, -2.88f)
                curveToRelative(0.56f, -1.28f, 1.74f, -3.50f, 1.84f, -5.27f)
                curveToRelative(0.05f, 0.04f, 0.22f, 0.14f, 0.29f, 0.20f)
                curveToRelative(0.22f, 0.13f, 0.38f, 0.33f, 0.59f, 0.47f)
                curveToRelative(0.21f, 0.20f, 0.48f, 0.34f, 0.88f, 0.34f)
                curveToRelative(0.04f, 0.00f, 0.08f, 0.01f, 0.11f, 0.01f)
                curveToRelative(0.41f, 0.0f, 0.73f, -0.13f, 1.00f, -0.27f)
                curveToRelative(0.29f, -0.13f, 0.52f, -0.33f, 0.74f, -0.4f)
                horizontalLineToRelative(0.01f)
                curveToRelative(0.47f, -0.14f, 0.84f, -0.40f, 1.04f, -0.7f)
                close()
                moveTo(16.43f, 16.27f)
                curveToRelative(0.04f, 0.6f, 0.34f, 1.25f, 0.88f, 1.38f)
                curveToRelative(0.59f, 0.13f, 1.43f, -0.33f, 1.79f, -0.77f)
                lineToRelative(0.21f, -0.01f)
                curveToRelative(0.32f, -0.01f, 0.58f, 0.01f, 0.85f, 0.27f)
                lineToRelative(0.00f, 0.00f)
                curveToRelative(0.21f, 0.20f, 0.31f, 0.53f, 0.39f, 0.88f)
                curveToRelative(0.09f, 0.4f, 0.15f, 0.78f, 0.41f, 1.07f)
                curveToRelative(0.49f, 0.53f, 0.65f, 0.91f, 0.64f, 1.14f)
                lineToRelative(0.00f, -0.01f)
                verticalLineToRelative(0.02f)
                lineToRelative(-0.00f, -0.01f)
                curveToRelative(-0.02f, 0.26f, -0.19f, 0.40f, -0.50f, 0.60f)
                curveToRelative(-0.63f, 0.40f, -1.75f, 0.71f, -2.46f, 1.57f)
                curveToRelative(-0.62f, 0.74f, -1.37f, 1.14f, -2.04f, 1.19f)
                curveToRelative(-0.66f, 0.05f, -1.24f, -0.2f, -1.57f, -0.90f)
                lineToRelative(-0.01f, -0.00f)
                curveToRelative(-0.21f, -0.4f, -0.12f, -1.03f, 0.06f, -1.69f)
                curveToRelative(0.18f, -0.67f, 0.43f, -1.34f, 0.46f, -1.90f)
                curveToRelative(0.04f, -0.71f, 0.08f, -1.34f, 0.20f, -1.81f)
                curveToRelative(0.12f, -0.47f, 0.31f, -0.80f, 0.64f, -0.98f)
                lineToRelative(0.05f, -0.02f)
                close()
                moveTo(5.61f, 16.32f)
                horizontalLineToRelative(0.01f)
                curveToRelative(0.05f, 0.0f, 0.11f, 0.01f, 0.16f, 0.01f)
                curveToRelative(0.38f, 0.06f, 0.71f, 0.33f, 1.02f, 0.75f)
                lineToRelative(0.91f, 1.66f)
                lineToRelative(0.00f, 0.00f)
                curveToRelative(0.24f, 0.53f, 0.75f, 1.06f, 1.19f, 1.64f)
                curveToRelative(0.43f, 0.60f, 0.77f, 1.13f, 0.73f, 1.57f)
                verticalLineToRelative(0.01f)
                curveToRelative(-0.06f, 0.74f, -0.48f, 1.15f, -1.13f, 1.29f)
                curveToRelative(-0.65f, 0.14f, -1.52f, 0.00f, -2.40f, -0.46f)
                curveToRelative(-0.97f, -0.54f, -2.12f, -0.47f, -2.86f, -0.60f)
                curveToRelative(-0.37f, -0.07f, -0.61f, -0.2f, -0.72f, -0.4f)
                curveToRelative(-0.11f, -0.2f, -0.11f, -0.60f, 0.12f, -1.23f)
                verticalLineToRelative(-0.00f)
                lineToRelative(0.00f, -0.00f)
                curveToRelative(0.12f, -0.33f, 0.03f, -0.75f, -0.03f, -1.12f)
                curveToRelative(-0.06f, -0.40f, -0.08f, -0.71f, 0.04f, -0.94f)
                curveToRelative(0.16f, -0.33f, 0.40f, -0.4f, 0.69f, -0.53f)
                curveToRelative(0.29f, -0.14f, 0.64f, -0.20f, 0.92f, -0.47f)
                horizontalLineToRelative(0.00f)
                verticalLineToRelative(-0.00f)
                curveToRelative(0.26f, -0.27f, 0.45f, -0.60f, 0.67f, -0.84f)
                curveToRelative(0.19f, -0.20f, 0.38f, -0.34f, 0.66f, -0.34f)
                close()
                moveTo(12.77f, 7.25f)
                curveToRelative(-0.44f, 0.20f, -0.95f, 0.54f, -1.49f, 0.54f)
                curveToRelative(-0.54f, 0.0f, -0.97f, -0.27f, -1.28f, -0.47f)
                curveToRelative(-0.15f, -0.13f, -0.28f, -0.27f, -0.37f, -0.34f)
                curveToRelative(-0.16f, -0.13f, -0.14f, -0.33f, -0.07f, -0.33f)
                curveToRelative(0.11f, 0.02f, 0.13f, 0.13f, 0.20f, 0.2f)
                curveToRelative(0.10f, 0.07f, 0.22f, 0.2f, 0.36f, 0.33f)
                curveToRelative(0.29f, 0.2f, 0.68f, 0.47f, 1.17f, 0.47f)
                curveToRelative(0.49f, 0.0f, 1.05f, -0.27f, 1.40f, -0.47f)
                curveToRelative(0.20f, -0.14f, 0.45f, -0.33f, 0.65f, -0.47f)
                curveToRelative(0.16f, -0.14f, 0.15f, -0.27f, 0.28f, -0.27f)
                curveToRelative(0.13f, 0.02f, 0.03f, 0.13f, -0.15f, 0.33f)
                arcToRelative(8.10f, 8.10f, 0.0f, false, true, -0.69f, 0.47f)
                close()
                moveTo(11.69f, 5.66f)
                lineTo(11.69f, 5.64f)
                curveToRelative(-0.01f, -0.02f, 0.01f, -0.04f, 0.03f, -0.05f)
                curveToRelative(0.07f, -0.04f, 0.18f, -0.03f, 0.26f, 0.00f)
                curveToRelative(0.06f, 0.0f, 0.16f, 0.07f, 0.15f, 0.14f)
                curveToRelative(-0.01f, 0.05f, -0.09f, 0.07f, -0.14f, 0.07f)
                curveToRelative(-0.06f, 0.0f, -0.09f, -0.04f, -0.14f, -0.07f)
                curveToRelative(-0.05f, -0.02f, -0.15f, -0.01f, -0.16f, -0.07f)
                close()
                moveTo(11.14f, 5.66f)
                curveToRelative(-0.02f, 0.06f, -0.11f, 0.05f, -0.17f, 0.07f)
                curveToRelative(-0.05f, 0.03f, -0.09f, 0.07f, -0.14f, 0.07f)
                curveToRelative(-0.05f, 0.0f, -0.13f, -0.02f, -0.14f, -0.07f)
                curveToRelative(-0.01f, -0.07f, 0.09f, -0.13f, 0.15f, -0.13f)
                curveToRelative(0.08f, -0.03f, 0.18f, -0.05f, 0.26f, -0.01f)
                curveToRelative(0.02f, 0.01f, 0.04f, 0.03f, 0.03f, 0.05f)
                verticalLineToRelative(0.02f)
                horizontalLineToRelative(0.00f)
                close()
            }
        }
        .build()
        return _linuxSimpleIcons!!
    }

private var _linuxSimpleIcons: ImageVector? = null
